<div class="mom-tabs-container">
  <mat-tab-group animationDuration="300ms">

    <!-- Counsellors MOM Tab - Always visible to all counsellors -->
    <mat-tab label="Counsellors MOM">
      <ng-template matTabContent>
        <div class="tab-content">
          <app-mom-counsellors></app-mom-counsellors>
        </div>
      </ng-template>
    </mat-tab>

    <!-- Management MOM Tab - Visible only to Kavita Shetty, Krisha Shah, or Lead Counsellor -->
    <mat-tab *ngIf="showManagementTab" label="Management MOM">
      <ng-template matTabContent>
        <div class="tab-content">
          <app-mom-management></app-mom-management>
        </div>
      </ng-template>
    </mat-tab>

    <!-- MOM with Kavita Tab - Visible only to Kavita Shetty, Krisha Shah, or Lead Counsellor -->
    <mat-tab *ngIf="showManagementTab" label="MOM with Kavita">
      <ng-template matTabContent>
        <div class="tab-content">
          <app-mom-kavita></app-mom-kavita>
        </div>
      </ng-template>
    </mat-tab>

    counselling-center-log  </mat-tab-group>
</div>

